export default "__VITE_ASSET__uTWoNO_h__"